import { render, staticRenderFns } from "./ManageHeader.vue?vue&type=template&id=bb12d6e2&scoped=true"
import script from "./ManageHeader.vue?vue&type=script&lang=js"
export * from "./ManageHeader.vue?vue&type=script&lang=js"
import style0 from "./ManageHeader.vue?vue&type=style&index=0&id=bb12d6e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb12d6e2",
  null
  
)

export default component.exports